<flowaccount-dac-intro></flowaccount-dac-intro>

<flowaccount-smooth-scroll-anchor-shared
  [styleClass]="'dac'"
  [contentScully]="'DAC_SCROLL_SECTION_LINK_KEY'"
  [contentSquidex]="'dac-scroll-section-link'"
></flowaccount-smooth-scroll-anchor-shared>

<flowaccount-dac-speakers></flowaccount-dac-speakers>

<flowaccount-dac-agenda></flowaccount-dac-agenda>

<flowaccount-dac-highlight></flowaccount-dac-highlight>

<flowaccount-dac-job-suitable></flowaccount-dac-job-suitable>

<flowaccount-dac-vdo-event></flowaccount-dac-vdo-event>

<flowaccount-promotional-banner-squidex
  [contentSquidex]="'dac-promotional-banner'"
  [contentScully]="'DAC_PROMOTIONAL_BANNER_KEY'"
  [styleClass]="'dac-promotional-banner'"
  [customId]="'dacTicketPhasing-id'"
></flowaccount-promotional-banner-squidex>

<flowaccount-faq-accordion-squidex
  [contentSquidex]="'digital-accounting-conference-faq'"
  [contentScully]="'digital-accounting-conference-faq-key'"
></flowaccount-faq-accordion-squidex>

<flowaccount-dac-sticky-banner></flowaccount-dac-sticky-banner>
